<template>
<div class="chapter">
<div class="inner_page">
<div class="box-f">
<h2 class="h2" id="contents"><a id="page_vii"></a>Contents</h2>
</div>
<p class="toc"><a class="nounder" href="#/xhtml/list#list"><em>List of Illustrations</em></a></p>
<p class="toc"><a class="nounder" href="#/xhtml/ack#ack"><em>Acknowledgments</em></a></p>
<p class="toc1"><a class="nounder" href="#/xhtml/ch01#ch01">1 The Noir Musical</a></p>
<p class="toc"><a class="nounder" href="#/xhtml/ch02#ch02">2 Preludes to the Noir Musical</a></p>
<p class="toc"><a class="nounder" href="#/xhtml/ch03#ch03">3 <em>Blues in the Night</em>: <em>The Noir Musical on the Brink of World War II</em></a></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample">4 Smoky Melodies: <em>Jazz Noir Musical Drama</em></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch05#ch05" title="Link target outside of Sample">5 Le Rouge et le Noir: <em>From</em> The Red Shoes <em>to</em> A Star Is Born</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch06#ch06" title="Link target outside of Sample">6 Dark Musical Melodrama: <em>From</em> Young at Heart <em>to</em> West Side Story</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch07#ch07" title="Link target outside of Sample">7 The Legacy of the Noir Musical</span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/notes#notes" title="Link target outside of Sample"><em>Notes</em></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/index#index" title="Link target outside of Sample"><em>Index</em></span></p>
<p class="toc"><a id="page_viii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?28b600b8